import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { PassengerType, TOURCODES_SELECT } from 'src/app/core/enums/enums';
import { IOsiWaiverTourcodeConfig } from 'src/app/core/models/agency-settings.model';
import { IReRouteModalQuote } from 'src/app/core/models/re-route.model';
import { ItineraryService } from 'src/app/search-result/services/itinerary.service';
import { SettingsService } from 'src/app/settings/services/settings.service';
import { ReRouteService } from 'src/app/re-route/services/re-route.service';
import { IBookingCredentialsData } from 'src/app/core/models/booking-credentials.model';
import { LayoutService } from 'src/app/layout/services/layout.service';

@Component({
  selector: 'app-re-route-modal',
  templateUrl: './re-route-modal.component.html',
  styleUrls: ['./re-route-modal.component.scss']
})
export class ReRouteModalComponent implements OnDestroy {
  @Input() isActive: boolean;
  @Input() showInfantWarning: boolean = false;
  @Input() isAirline: boolean = false;

  @Output() sendData = new EventEmitter<IReRouteModalQuote>();
  @Output() closeModal = new EventEmitter<boolean>();

  subscriptions = new Subscription();

  form: FormGroup;
  credentialsData: IBookingCredentialsData;
  aditionalFieldsConfig: IOsiWaiverTourcodeConfig = null;
  validPassengers = false;
  tourCodes = TOURCODES_SELECT;

  constructor(
    private fb: FormBuilder,
    private settingsService: SettingsService,
    private itineraryService: ItineraryService,
    private reRouteService: ReRouteService,
    private layoutService: LayoutService
  ) {
    this.reRouteService.dispatchResetReRouteState();
    this.buildForm();
    this.callComponentSubscriptions();
  }

  buildForm() {
    this.form = this.fb.group({
      waiver: [''],
      tourCode: [''],
      /**
       * ! Do not delete this comment !
       * * Note: ticketNumbers below are the OSIS strings
       * * but the name is because of the child <app-select-and-field> Angular Component
       */
      ticketNumbers: this.fb.array([])
    });
  }

  callComponentSubscriptions() {
    this.subscriptions.add(
      /**
       ** Checking if passengers are valid
       */
      this.itineraryService.getSelectedPassengersQuote().subscribe((passengers) => {
        if (passengers && passengers.length > 0) {
          let hasAtLeastOneAdult = false;

          passengers.forEach((passenger) => {
            switch (passenger.passengerType) {
              case PassengerType.Adult:
                hasAtLeastOneAdult = true;
                break;

              default:
                break;
            }
          });

          if (hasAtLeastOneAdult) {
            this.validPassengers = true;
          } else {
            this.validPassengers = false;
          }
        } else {
          this.validPassengers = false;
        }
      })
    );
    this.subscriptions.add(
      this.settingsService.getClientSettings().subscribe((settings) => {
        this.aditionalFieldsConfig = {
          osiEnabled: settings?.exchangeAdditionalFields?.noshowRegulation?.osiEnabled,
          waiverEnabled: settings?.exchangeAdditionalFields?.noshowRegulation?.waiverEnabled,
          tourcodeEnabled: settings?.exchangeAdditionalFields?.noshowRegulation?.tourcodeEnabled
        };
      })
    );
    this.subscriptions.add(
      this.layoutService.getBookingCredentialsState().subscribe((credentials) => {
        this.credentialsData = credentials.data;
      })
    );
  }

  addOSIToForm(value: string) {
    const ticktes = this.form.controls.ticketNumbers as FormArray;
    ticktes.push(this.fb.control(value.toUpperCase()));
  }

  deleteOSI(index: number) {
    const ticktes = this.form.controls.ticketNumbers as FormArray;
    ticktes.removeAt(index);
  }

  disabledContinueButton() {
    let enabledButton = false;
    if (this.aditionalFieldsConfig.osiEnabled) {
      enabledButton = this.form.value.ticketNumbers;
    }
    if (this.aditionalFieldsConfig.tourcodeEnabled) {
      enabledButton = this.form.value.tourCode;
    }
    if (this.aditionalFieldsConfig.waiverEnabled) {
      enabledButton = this.form.value.waiver;
    }

    return !(this.validPassengers && enabledButton);
  }

  submit() {
    const modalQuote: IReRouteModalQuote = {
      waiver: this.form.value.waiver,
      tourCode: this.form.value.tourCode,
      osis: this.form.value.ticketNumbers,
      overSign: this.credentialsData
    };
    this.sendData.emit(modalQuote);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
